import React from 'react';

const H3 = props => <h3 className={'ds-h3'} {...props}>{props.children}</h3>;

export default H3; 